export const getDate = (value) => {
    var month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var newDateStr = '';
    var currentDate = new Date();
    if (value) {
        var dateString = value.split('T')[0];
        var date = dateString.split('-')[2];
        var strYear = dateString.split('-')[0];
        if (date.charAt(0) == '0') {
            date = date.substring(1);
        }
        newDateStr = date + ' ' +
            month[dateString.split('-')[1] - 1];
        if (strYear != currentDate.getFullYear()) {
            newDateStr += (" '" + strYear.substring(2));
        }
    }
    return newDateStr;
}

export const getTime = (value) => {
    if (value) {
        var timeString = value.split("T")[1];
        var H = Number(timeString.substr(0, 2));
        var h = (H % 12) || 12;
        var ampm = timeString.split(" ")[1] ? timeString.split(" ")[1] : H < 12 ? "AM" : "PM";
        timeString = h + timeString.substr(2, 3) + " " + ampm;
        return timeString;
    }
}

export function getExportDownloadLink(fileId) {
  return `/marketplace/download-file/ajax/downloadGeneratedExportFile.service?fileId=${fileId}`;
}

export function getExportErrorFileLink(fileId){
    return `/marketplace/static/php/web/b2bWebsite.php?action=downloadErrorFile&errorFileId=${fileId}`;
    // return `/marketplace/download-file/ajax/downloadFailedValidationFile.service?fileName=${failedFileName}`
}

export function isValidExcel(file) {
    const regex = /(xls|xlsx|csv)/i;
    if(!regex.test(file?.name)){
        return { error: 'File Extension is not valid' }
    }
    // if(file.size / 1024 / 1024 > 100 ){
    //     return { error: 'File Size Exceed' }
    // }
    return { data: true }
}